import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/Home.vue'
import eventBus from '../components/eventbus'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/solution',
    name: 'solution',
    component: () => import(/* webpackChunkName: "about" */ '../views/solution/Index.vue')
  },
  {
    path: '/deploy',
    name: 'deploy',
    component: () => import(/* webpackChunkName: "about" */ '../views/deploy/Index.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/about/Index.vue')
  },
  {
    path: '/news',
    name: 'news',
    component: () => import(/* webpackChunkName: "news" */ '../views/news/Index.vue')
  },
  {
    path: '/service',
    name: 'service',
    component: () => import(/* webpackChunkName: "service" */ '../views/service/Index.vue')
  },
  {
    path: '/service/serviceDetails',
    name: 'serviceDetails',
    component: () => import(/* webpackChunkName: "serviceDetails" */ '../views/service/ServiceDetails.vue')
  },
  {
    path: '/news/newsDetails',
    name: 'newsDetails',
    component: () => import(/* webpackChunkName: "newsDetails" */ '../views/news/NewsDetails.vue')
  },

]

const router = new VueRouter({
  mode: 'hash', //history
  base: process.env.BASE_URL,
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

router.afterEach(() => {
  eventBus.$emit('onRoute')
})

export default router
